export const routesOkulZiyaret = [
  {
    path: "/okulziyaret",
    name: "okulziyaret",
    component: () => import("@/views/okulziyaret/index.vue"),
    meta: {
      public: false,
      title: "Okul Ziyaret",
      yetki: { k: [] },
    },
  },
  {
    path: "/okulziyaret-rapor",
    name: "okulziyaret_rapor",
    component: () => import("@/views/okulziyaret/rapor/index.vue"),
    meta: {
      public: false,
      title: "Okul Ziyaret Raporu",
      yetki: { k: [] },
    },
  },
]
